import { useParams } from 'react-router';
import { useChannel } from '../store/useChannelHooks';
import { usePatientGuids } from '../store/usePatientHooks';

export const useCurrentPatientGuid = (): string | undefined => {
  const { channelGuid } = useParams<{ channelGuid: string }>();
  const channel = useChannel(channelGuid ?? '');
  const patientGuids = usePatientGuids();
  const currentPatientGuid = channel?.attributes?.patientGuid;
  return currentPatientGuid ?? patientGuids[0];
};
